import { cartFields } from '@pylot-data/core-queries/cart'

export const removeItemFromCartMutation = /* GraphQL */ `
    mutation removeItemFromCart($input: RemoveItemFromCartInput, $isSignedIn: Boolean = false) {
        removeItemFromCart(input: $input){
            cart {
                ${cartFields}
            }
        }
    }
`
